/* eslint-disable react/jsx-no-target-blank */
/* eslint no-nested-ternary: 0, react/no-unused-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from '@aws-amplify/auth';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Grid,
  Header,
  Loader,
  Menu,
  Segment,
} from 'semantic-ui-react';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import clone from 'clone';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import NavBar from '../../components/NavBar';
import Identity from '../../components/Identity';

import CreditCheckComp from '../CreditCheck/NewCreditCheck';
import CreditCheckSplash from '../../components/NewCreditCheckSplash';
import InsufficientCreditCheckModal from '../modals/InsufficientCreditCheck';
import config from '../../../config';

class CreditCheck extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
      customerID: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      companyBranch: PropTypes.shape({
        service_company_branch_id: PropTypes.string,
      }),
    }),
    onCheck: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static defaultCustomerData = {
    id: '',
    customerDetailID: '',
    identityTypeID: '',
    identity: '',
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    incomeID: '',
    customerCreditReports: [],
    customerCreditReport: null,
    runCreditCheck: false,
  }
  static defaultCustomerDetailData = {
    title: '',
    name: '',
    preferredName: '',
    email: '',
    mobilePrefix: '',
    mobile: '',
    phonePrefix: '',
    phone: '',
    address1: '',
    address2: '',
    city: '',
    postcode: '',
    state: '',
    country: '',
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const data = Object.assign({}, CreditCheck.defaultCustomerData, props.data || {});
    const errMessages = [];
    if (!data.customerDetailID) {
      data.customerDetail = Object.assign({}, CreditCheck.defaultCustomerDetailData);
    }
    return {
      data,
      errMessages,
      oriData: clone(data),
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = CreditCheck.getPropsToState(props);
    this.state = {
      ...state,
      hasChanges: false,
      runCreditCheck: false,
      openInsufficientCreditModal: false,
      creditSubscription: {
        amount: 0,
      },
    };
  }
  componentDidMount() {
    if (location.search !== '') {
      const values = queryString.parse(this.props.location.search);
      if (values.runCreditCheck === 'true') {
        this.fetchBookingCustomer();
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = CreditCheck.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setLoading = (loading = false) => (
    new Promise((res) => {
      this.setState({ loading }, res);
    })
  )
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  async fetchBookingCustomer() {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      if (this.props.location.pathname.includes('bookings/')) {
        res = await store.dispatch(fetchM(`/customers/${this.props.params.customerID}/`, {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }));
      } else {
        res = await store.dispatch(fetchM(`/customers/${this.props.params.id}/`, {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }));
      }
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newData = Object.assign({}, json || {});
      this.setState({ data: newData, runCreditCheck: true });
    }
    await this.setLoading(false);
  }
  fetchValue() {
    let values = '';
    if (location.search !== '') {
      values = queryString.parse(this.props.location.search);
      if (values.runCreditCheck === 'true' && !this.state.runCreditCheck) {
        this.setState({ runCreditCheck: true });
      }
    }
  }
  getCreditsSubscriptionFragment = () => `
    id
    company_id
    company_branch_id
    amount
    currency_code
    created_at
    created_by
    updated_at
    updated_by
  `
  handleChange = (event, value) => {
    const { data } = this.state;
    data[value.name] = value.value;
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckAvailableCredits = () => {
    const { companyBranch } = this.props.auth;
    this.setState({ loading: true });
    let availableCredit = 0;

    const { store } = this.context;
    const id = companyBranch && companyBranch.service_company_branch_id;
    Auth.currentSession()
    .then((result) => {
      let creditsSubscriptionToken = (result).getIdToken().getJwtToken();
      if (config.get('server') === 'development') {
        creditsSubscriptionToken = config.get('subsAuth');
      }
      fetch(config.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken,
        },
        body: JSON.stringify({
          query: `
            query {
              getSubscription(
                id: "${id}",
              ) { ${this.getCreditsSubscriptionFragment()} }
            }
          `,
        }),
      })
      .then(async (res) => {
        if (res.ok) {
          const { data } = await res.json();
          if (data && data.getSubscription) {
            availableCredit = data.getSubscription.amount;
            this.setState({
              creditSubscription: { ...data.getSubscription },
            });

            if (availableCredit < 10) {
              this.setState({ openInsufficientCreditModal: true });
            } else {
              this.runCreditCheck();
            }
          }
        } else {
          const message = 'Failed to retrieve subscription data';
          store.dispatch(flashErrorMessage(message));
        }
      });
    })
    .catch(err => store.dispatch(flashErrorMessage(err)));
    this.setState({ loading: false });
  }
  handleCloseInsufficientCreditModal = (e) => {
    e.preventDefault();
    this.setState({ openInsufficientCreditModal: false });
  }
  handleRefetch = () => {
    const { store } = this.context;
    if (this.pathCheck(this.props)) {
      store.dispatch(push(`/bookings/${this.props.params.id}/customers/${this.state.data.id}/credit_check/`));
    } else {
      store.dispatch(push(`/customers/${this.state.data.id}/credit_check/`));
    }
  }
  pathCheck = (props) => {
    const { pathname } = props.location;
    if (pathname.includes('/bookings/')) {
      return true;
    }
    return false;
  }
  runCreditCheck = () => {
    this.setState({ runCreditCheck: true });
  }
  render() {
    const { data, openInsufficientCreditModal } = this.state;
    return (
      <Container>
        <InsufficientCreditCheckModal
          open={openInsufficientCreditModal}
          onClose={e => this.handleCloseInsufficientCreditModal(e)}
        />
        <NavBar
          header="Credit Check"
          rightNav={this.hasAccess() && !this.pathCheck(this.props) &&
            <Menu.Item fitted>
              <Button
                as={Link}
                to={'/customers/manage/credit_checks/'}
                disabled={this.state.loading}
                primary
                icon="setting"
                content="Manage"
              />
            </Menu.Item>
          }
        />
        <Grid>
          <Grid.Row>
            <Grid.Column className="mobile-no-padding">
              <Dimmer active={this.state.loading} inverted>
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              {
                !this.state.runCreditCheck && this.pathCheck(this.props) ?
                  <div className="outerDiv">
                    <Divider horizontal>Credit Check</Divider>
                    <Container className="outerContainer" textAlign="center">
                      <Header
                        as="h2"
                        style={{
                          marginBottom: '2em',
                          color: 'rgba(0, 35, 59, 1)',
                        }}
                        content={data.customerDetail.name}
                        subheader={
                          <Header.Subheader style={{ color: 'rgba(0, 35, 59, 1)', fontWeight: 'bold' }}>
                            <p style={{ marginBottom: '0' }} >
                              {data.customerDetail.preferredName || 'Customer'}
                            </p>
                            <Identity
                              type={data.identityTypeID}
                              identity={data.identity || 'XXXXXXXXXXXX'}
                              style={{ color: 'black' }}
                            />
                          </Header.Subheader>
                        }
                      />
                      <Header
                        as="h3"
                        style={{ margin: '1em 0', color: 'rgba(89, 105, 117, 1)' }}
                      >
                        Credit Check helps purchasers to know their loan eligibility.
                        <Header.Subheader style={{ marginTop: '0.25em', color: 'rgba(89, 105, 117, 1)' }}>Follow these simple steps to get purchaser’s CTOS and DSR (Debt Service Ratio) score.</Header.Subheader>
                      </Header>
                      <div className="new-credit-check">
                        <Container style={{ border: '1px solid rgb(217, 218, 220)', padding: '3rem', borderRadius: '0.25rem', backgroundColor: 'rgba(229, 244, 245, 1)', marginTop: '2em' }} textAlign="center">
                          <CreditCheckSplash
                            actionNode={
                              <Grid.Row textAlign="center">
                                <Grid.Column
                                  mobile={16}
                                  tablet={6}
                                  computer={data.customerCreditReportID ? 5 : 4}
                                >
                                  <div className="runCreditCheckButton" style={{ marginTop: '1rem' }}>
                                    <Button
                                      fluid
                                      positive
                                      onClick={this.handleCheckAvailableCredits}
                                      disabled={this.state.loading}
                                    >
                                      {data.customerCreditReportID ? 'Begin Credit Check' : 'Run Credit Check'}
                                    </Button>
                                  </div>
                                </Grid.Column>
                              </Grid.Row>
                            }
                          />
                        </Container>
                      </div>
                      <Header
                        as="h4"
                        style={{ color: '#596975', marginTop: '3rem' }}
                      >
                        To top-up credits, please contact<br />
                        <a
                          className="consentLink"
                          href={'mailto:support@mhub.my'}
                        >
                          support@mhub.my
                        </a>
                      </Header>
                    </Container>
                  </div> : null
              }
              {
                this.state.runCreditCheck && this.pathCheck(this.props) ?
                  <CreditCheckComp
                    auth={this.props.auth}
                    bookingID={this.props.params.id}
                    data={this.state.data}
                    pathCheck={this.pathCheck(this.props)}
                    loading={this.state.loading}
                    setLoading={this.setLoading}
                    customerID={data.id || ''}
                    onChange={this.handleOnCheck}
                    icFrontDocumentID={data.icFrontDocumentID || ''}
                    icFrontDocument={data.icFrontDocument || null}
                    icBackDocumentID={data.icBackDocumentID || ''}
                    icBackDocument={data.icBackDocument || null}
                    incomeID={data.incomeID || ''}
                    income={data.income || null}
                    customerCreditReport={data.customerCreditReport || null}
                    customerCreditReports={data.customerCreditReports || []}
                    customerDetail={data.customerDetail || null}
                    refetch={this.handleRefetch}
                    identityTypeID={data.identityTypeID || 0}
                    identity={data.identity || ''}
                    location={location}
                  /> : null
              }
              {
                !this.pathCheck(this.props) && data.id !== '' ?
                  <CreditCheckComp
                    auth={this.props.auth}
                    bookingID={this.props.params.id}
                    data={this.state.data}
                    pathCheck={this.pathCheck(this.props)}
                    loading={this.state.loading}
                    setLoading={this.setLoading}
                    customerID={data.id || ''}
                    onChange={this.handleOnCheck}
                    icFrontDocumentID={data.icFrontDocumentID || ''}
                    icFrontDocument={data.icFrontDocument || null}
                    icBackDocumentID={data.icBackDocumentID || ''}
                    icBackDocument={data.icBackDocument || null}
                    incomeID={data.incomeID || ''}
                    income={data.income || null}
                    customerCreditReport={data.customerCreditReport || null}
                    customerCreditReports={data.customerCreditReports || []}
                    customerDetail={data.customerDetail || null}
                    refetch={this.handleRefetch}
                    identityTypeID={data.identityTypeID || 0}
                    identity={data.identity || ''}
                    location={location}
                  /> : null
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default connect(CreditCheck.mapStateToProps)(CreditCheck);



// WEBPACK FOOTER //
// ./src/containers/Customers/CreditCheck.jsx